import React from 'react';
import { Box, Container, Typography, Chip, Paper, useTheme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';

const Skills = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const skillCategories = [
    {
      title: 'Strategic Leadership',
      skills: [
        'Strategic Sales Leadership',
        'Market Analysis & Competitive Intelligence',
        'Key Account Management (KAM)',
        'Cross-functional Team Leadership',
        'Global Business Expansion',
      ],
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
    {
      title: 'Marketing & Branding',
      skills: [
        'Brand Development & Positioning',
        'Integrated Marketing Communications',
        'Product Innovation & Lifecycle Management',
        'Digital Transformation',
      ],
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
    {
      title: 'Business Operations',
      skills: [
        'Sales Forecasting & Pipeline Management',
        'Customer Relationship Management (CRM)',
        'Financial Acumen & Profitability Optimization',
        'Negotiation & Contract Management',
        'Crisis Management & Problem Resolution',
        'Data-Driven Decision Making',
      ],
      gradient: 'linear-gradient(90deg, #0968E5, #091970)',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6 },
    },
  };

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        background: 'linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%)',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant={isMobile ? 'h4' : 'h3'}
          sx={{
            textAlign: 'center',
            mb: { xs: 4, sm: 5, md: 6 },
            fontWeight: 700,
            background: 'linear-gradient(90deg, #0968E5, #091970)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontSize: { xs: '1.75rem', sm: '2rem', md: '2.5rem', lg: '3rem' },
          }}
        >
          Core Competencies
        </Typography>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                md: 'repeat(3, 1fr)',
              },
              gap: 4,
            }}
          >
            {skillCategories.map((category, index) => (
              <motion.div key={index} variants={itemVariants}>
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 3, md: 4 },
                    borderRadius: 4,
                    background: 'linear-gradient(135deg, rgba(9, 104, 229, 0.05) 0%, rgba(9, 25, 112, 0.05) 100%)',
              border: '1px solid rgba(9, 104, 229, 0.2)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 10px 40px rgba(9, 104, 229, 0.3)',
              },
                  }}
                >
                  <Box
                    sx={{
                      height: 4,
                      borderRadius: 2,
                      background: category.gradient,
                      mb: 3,
                    }}
                  />
                  <Typography
                    variant={isMobile ? 'h6' : 'h5'}
                    sx={{
                      fontWeight: 700,
                      mb: { xs: 2, md: 3 },
                      color: '#333',
                      fontSize: { xs: '1rem', sm: '1.15rem', md: '1.25rem' },
                    }}
                  >
                    {category.title}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 1.5,
                    }}
                  >
                    {category.skills.map((skill, skillIndex) => (
                      <Chip
                        key={skillIndex}
                        label={skill}
                        sx={{
                          background: category.gradient,
                          color: 'white',
                          fontWeight: 400,
                          fontSize: { xs: '0.7rem', sm: '0.75rem', md: '0.8rem', lg: '0.85rem' },
                          height: { xs: 26, sm: 28, md: 30, lg: 32 },
                          '&:hover': {
                            transform: 'scale(1.05)',
                          },
                          transition: 'transform 0.2s ease',
                        }}
                      />
                    ))}
                  </Box>
                </Paper>
              </motion.div>
            ))}
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Skills;

